_collow.components.CompanyProfile = class CompanyProfile extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  lastTrigger;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    
  }
};
